import type { DbSubmissionBlock } from '@domain/schemas/block.schema';

export const isSummaryBlock = (block?: Pick<DbSubmissionBlock, 'sk'>) => block?.sk?.startsWith('summary_blocks#');
